import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_GM_COUNTRY, GET_GM_COUNTRY_SUCCESS, GET_GM_COUNTRY_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getGmCountry({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/gm-dashboard-filters/country`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_GM_COUNTRY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GM_COUNTRY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GM_COUNTRY_ERROR, payload: error });
  }
}

export function* watchGetGmCountry() {
  yield takeEvery(GET_GM_COUNTRY, getGmCountry);
}

function* getGmCountrySaga() {
  yield all([fork(watchGetGmCountry)]);
}

export default getGmCountrySaga;